import React from "react";
import PropTypes from "prop-types";
import Humanizer from 'humanize-duration-es6';

import config from "../Config";

const Style = {
    container:{
        flexDirection:"row",
        alignItems:"center",
    },
    timerContainer:{
        backgroundColor:"#fff",
        borderRadius:15,
        border: "1px solid red",
        display: 'flex',
        padding: 5
    },
    timerText:{
        fontWeight:600,
        fontSize:13,
        margin: "0px 2px",
    }
};

const shortEnLocale = {
    y: () => "y",
    mo: () => "mo",
    w: () => "w",
    d: () => "d",
    h: () => "h",
    m: () => "m",
    s: () => "s",
    ms: () => "ms",
    decimal: () => "."
};

const shortEsLocale = {
    y: () => "año",
    mo: () => "mes",
    w: () => "semana",
    d: () => "día",
    h: () => "hora",
    m: () => "minuto",
    s: () => "segundos",
    ms: () => "Milisegundos",
    decimal: () => "."
};


const shortEnglishHumanizer = new Humanizer(shortEnLocale, {
    spacer: "",
    delimiter: " "
});

const shortSpanishHumanizer = new Humanizer(shortEsLocale, {
    spacer: "",
    delimiter: " "
});


class Timer extends React.Component {
    
    constructor(props){
        super(props);
        const today = new Date();
        this.endDate = today.setSeconds(today.getSeconds() + this.props.timeLeft)        
        this.getFullTime = this.getFullTime.bind(this);
        this.state = this.getFullTime();
    }

    getFullTime(){
        const computationTime = this.endDate - new Date().getTime();
        //console.log(this.endDate , " comput ",computationTime,"  ", shortEnglishHumanizer.humanize(computationTime, { spacer: '', largest: 3, round: true }));
        
        let host = window.location.hostname;
        let subDomain = host.split('.')[0];
        console.log(" SUB APP Timer ",subDomain);
        if(subDomain==='epu'){
            return {
                shortTime: shortSpanishHumanizer.humanize(computationTime, { spacer: '', largest: 3, round: true }),
                computationTime: computationTime,
                minWidth: 70
            }
        }else{
            return {
                shortTime: shortEnglishHumanizer.humanize(computationTime, { spacer: '', largest: 3, round: true }),
                computationTime: computationTime,
                minWidth: 70
            }
        }
    }
   

    componentWillMount(){
        const {onTimerComplete} = this.props;
        this.timer = setInterval(_=>{
            const { computationTime, shortTime} = this.getFullTime();
            if(computationTime > 0) {
                this.setState({
                    shortTime,
                    minWidth: shortTime.length*7.8
                });
            } else {
                clearInterval(this.timer);
                onTimerComplete && onTimerComplete();
                this.setState({
                    shortTime: "0s"
                });
        }},1000);
    }

    componentWillUnmount(){
        clearInterval(this.timer);
    }

    render() {
        const {shortTime,minWidth} = this.state;
        const {style,showWatch,timerStyle} = this.props;
        return <div style={{...Style.container, ...style}}>
            <div style={{...Style.timerContainer, ...timerStyle}}>
                { showWatch && <img  src={`${config.MRBIDNWIN_S3_IMAGE_URL}/ic_auctions_timer.svg`} alt="Start-Timer"/>}
                <span style={{...Style.timerText, minWidth: minWidth }} className="montserratLight">{shortTime}</span>
            </div>
        </div>
    }
}

Timer.defaultProps = {
    timeLeft:0,
    style:{},
    timerStyle: {},
    showWatch: true
};

Timer.propTypes = {
    timeLeft:PropTypes.number.isRequired,
    style:PropTypes.object
};

export default Timer;



// WEBPACK FOOTER //
// ./src/components/Timer.js